import requests from "./httpService";

const PolicyServices = {
  getHRPolicy(id, body) {
    return requests.get(`/hrpolicy/all?company_id=${id}`, body);
  },
  getUserLeavePolicy(companyId, userId) {
    return requests.get(`/hrpolicy/get-user-leave-policies?company_id=${companyId}&user_id=${userId}`);
  },


  getUsersCheck(id, body) {
    return requests.get(`/hrpolicy/getUsers?company_id=${id}`, body);
  },
  createHRPolicy(body) {
    return requests.post(`/hrpolicy/create`, body);
  },
  updateHRPolicy(id, body) {
    return requests.post(`/hrpolicy/update/${id}`, body);
  },
  getPolicyDetails(id, body) {
    return requests.get(`/hrpolicy/detail/${id}`, body);
  },
  duplicateHRPolicy(id, body) {
    return requests.post(`/hrpolicy/duplicate/${id}`, body);
  },
};

export default PolicyServices;
